import API from "components/Apis/API"

export const getData = async (
  selected,
  setSummaryData,
  setDetailData
) => {
  const url = "admin/get_gross_margin"
  let formData = new FormData()
  formData.append("sales", JSON.stringify(selected.sales))
  formData.append("customer", JSON.stringify(selected.customer))
  formData.append("accountManagement", JSON.stringify(selected.AM))
  formData.append("start", selected.start)
  formData.append("end", selected.end)
  const response = await API.postData(url, formData)
  const data = response.data
  if (response.status)
  {
    setSummaryData(data.summary)
    setDetailData(data.detail)
  }

}

export const fetchSelectors = async (setSelectors) => {  
  const url = "admin/get_gross_margin";
  let formData = new FormData();
  formData.append("sales", JSON.stringify([]));
  formData.append("customer", JSON.stringify([]));
  formData.append("accountManagement", JSON.stringify([]));

  formData.append("start", document.getElementById("start").value);
  formData.append("end", document.getElementById("end").value);

  const response = await API.postData(url, formData);
  const data = response.data;
  if (response.status)
  {
    const selectorsData = {
      sales: data.sales,
      customer: data.customer,
      AM: data.accountManagement
    };

    setSelectors(selectorsData);
  }

};

export const defaultSelectors = async () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const url = "admin/get_gross_margin";
  let formData = new FormData();
  formData.append("sales", JSON.stringify([]));
  formData.append("customer", JSON.stringify([]));
  formData.append("accountManagement", JSON.stringify([]));

  formData.append("start", formatDate(start));
  formData.append("end", formatDate(end));

  const response = await API.postData(url, formData);
  const data = response.data;
  if (response.status)
  {
    return { sales: data.sales, 
      customer: data.customer, 
      AM: data.accountManagement, };
  }
  else
  {
    return { sales: [], customer: [],
      AM: [], };
  }

};

export const defaultSelected = () => {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth(), 1)
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)

  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  return {
    sales: [],
    customer: [],
    AM: [],
    start: formatDate(start),
    end: formatDate(end),
  }
}

export const defaultSortConfig = () => ({ key: null, direction: "ascending" })

export const formatNumber = (number) => {
  if (number === null || number === undefined || number === "") {
    return "0"
  }
  return number.toLocaleString()
}
